const aveniPink = {
  main: "#ec027f",
  light: "#ff229f",
  dark: "#cc004f",
};

export { aveniPink };
